function handleSlideContent(flkty) {
    // 1. Reset all videos to prevent background noise/overlap
    flkty.cells.forEach((cell) => {
        const v = cell.element.querySelector('video');
        if (v) {
            v.pause();
            v.currentTime = 0;
            // Clear any old listeners so they don't stack up
            v.onended = null;
        }
    });

    const video = flkty.selectedCell.element.querySelector('video');

    if (video) {
        // Pause standard 5s timer so the video can finish
        flkty.stopPlayer();
        video.muted = true;
        video.playsInline = true;

        const attemptPlay = () => {
            video.play().catch(err => console.warn('Playback blocked:', err));
        };

        if (video.readyState >= 3) {
            attemptPlay();
        } else {
            video.addEventListener('canplay', attemptPlay, { once: true });
        }

        // Use .onended instead of .addEventListener to ensure only ONE listener exists
        video.onended = () => {
            flkty.next();
        };
    } else {
        // If it's an image, resume the 5s autoPlay timer
        flkty.playPlayer();
    }
}

const slider = document.querySelector('.js-hero-slider');

if (slider) {
    const flkty = new window.Flickity(slider, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
        autoPlay: 5000,
        pauseAutoPlayOnHover: false,
        on: {
            ready() {
                handleSlideContent(this);
            },
            change() {
                handleSlideContent(this);
            },
        },
    });

    // Manual navigation buttons
    const prevButton = document.querySelector('.js-hero-slider-previous');
    if (prevButton) {
        prevButton.addEventListener('click', () => {
            flkty.stopPlayer();
            flkty.previous();
        });
    }

    const nextButton = document.querySelector('.js-hero-slider-next');
    if (nextButton) {
        nextButton.addEventListener('click', () => {
            flkty.stopPlayer();
            flkty.next();
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/heroSlider.js